var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "QR2",
    imageRendering: "auto",
    baseProfile: "basic",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    filterUnits: "objectBoundingBox",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "1 0 0 0 1 0 1 0 0 1 0 0 1 0 1 0 0 0 9999999999999.99 0",
    result: "colorTrans"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MASK",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F00",
    stroke: "none",
    d: "M1 -1L-1 -1 -1 1 1 1 1 -1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scene-1",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EyeTopLeft",
    transform: "matrix(.2 0 0 .2 12 13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "12,13;12,13"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.82799;.994;1",
    values: ".2,.2;1,1;1,1;.2,.2;.2,.2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.82799;.994;1",
    values: "-.25,-.25;0,0;0,0;-.25,-.25;-.25,-.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.82799;.994;1",
    values: "0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80DBFF",
    stroke: "none",
    d: "M5 -4Q5 -5 4 -5L-4 -5Q-5 -5 -5 -4L-5 4Q-5 4.4 -4.7 4.7 -4.45 5 -4 5L4 5Q4.4 5 4.7 4.7 5 4.4 5 4L5 -4M3 -3L3 3 -3 3 -3 -3 3 -3Z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EyeTopRight",
    transform: "matrix(.2 0 0 .2 36 13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "36,13;36,13"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.217;.77199;.939;1",
    values: ".2,.2;.2,.2;1,1;1,1;.2,.2;.2,.2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.217;.77199;.939;1",
    values: "-.25,-.25;-.25,-.25;0,0;0,0;-.25,-.25;-.25,-.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.217;.77199;.939;1",
    values: "0;0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80DBFF",
    stroke: "none",
    d: "M5 -4Q5 -5 4 -5L-4 -5Q-5 -5 -5 -4L-5 4Q-5 5 -4 5L4 5Q4.4 5 4.7 4.7 5 4.4 5 4L5 -4M3 -3L3 3 -3 3 -3 -3 3 -3Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.944;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EyeBottomLeft",
    transform: "matrix(.2 0 0 .2 12 35)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "12,35;12,35"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.272;.71699;.883;1",
    values: ".2,.2;.2,.2;1,1;1,1;.2,.2;.2,.2"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.272;.71699;.883;1",
    values: "-.25,-.25;-.25,-.25;0,0;0,0;-.25,-.25;-.25,-.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.272;.71699;.883;1",
    values: "0;0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80DBFF",
    stroke: "none",
    d: "M5 -4Q5 -5 4 -5L-4 -5Q-5 -5 -5 -4L-5 4Q-5 4.4 -4.7 4.7 -4.45 5 -4 5L4 5Q4.4 5 4.7 4.7 5 4.4 5 4L5 -4M3 -3L3 3 -3 3 -3 -3 3 -3Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.889;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DotTopLeft",
    transform: "translate(12 13)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.217;.77199;.939;1",
    values: "0;0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 -1L-1 -1 -1 1 1 1 1 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.056;.944;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DotTopRight",
    transform: "translate(36 13)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.272;.71699;.883;1",
    values: "0;0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 -1L-1 -1 -1 1 1 1 1 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.889;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DotBottomLeft",
    transform: "translate(12 35)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.328;.66099;.828;1",
    values: "0;0;1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 -1L-1 -1 -1 1 1 1 1 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.833;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_6)",
    id: "Layer25_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M25 14L25 13 21 13 21 8 19 8 19 14Q19 15 20 15L24 15Q24.4 15 24.7 14.7 25 14.4 25 14Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.911;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(20 7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.05;.078;.82799;.856;.906;1",
    values: "20,7;19.75,11.575;22.029,11.8;22.029,11.8;19.75,11.575;20,7;20,7"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.05;.078;.82799;.856;.906;1",
    values: "1,1;1.25,4.5;3.525,4.5;3.525,4.5;1.25,4.5;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.05;.078;.82799;.856;.906;1",
    values: "0,0;0,-.25;-.15,-.3;-.15,-.3;0,-.25;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.911;1",
    values: "inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_5)",
    id: "Layer24_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M29 9Q29 8 28 8L24 8Q23 8 23 9L23 13 25 13 25 10 29 10 29 9Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.839;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(24 14)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.04999;.1;.128;.75599;.783;.833;1",
    values: "24,14;24,14;23.78,12.325;26.174,12.5;26.174,12.5;23.78,12.325;24,14;24,14"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.04999;.1;.128;.75599;.783;.833;1",
    values: "1,1;1,1;1.3,3.5;3.492,3.5;3.492,3.5;1.3,3.5;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.04999;.1;.128;.75599;.783;.833;1",
    values: "0,0;0,0;-.1,-.25;-.15,-.3;-.15,-.3;-.1,-.25;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.839;1",
    values: "inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code1_3",
    transform: "matrix(1 0 0 .04 28 9.45)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.117;.161;.71099;.756;1",
    values: "28,9.552;28,9.552;28,12.5;28,12.5;28,9.552;28,9.552"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.117;.161;.71099;.756;1",
    values: "1,.04;1,.04;1,1;1,1;1,.04;1,.04"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.117;.161;.71099;.756;1",
    values: "0,-2.55;0,-2.55;0,-2.5;0,-2.5;0,-2.55;0,-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 5L1 0 -1 0 -1 5 1 5Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.117;.761;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code25",
    transform: "matrix(.067 0 0 1 9.85 21)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.25;.66099;.75;1",
    values: "9.95,21;9.95,21;8.5,21;8.5,21;9.95,21;9.95,21"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.25;.66099;.75;1",
    values: ".067,1;.067,1;1,1;1,1;.067,1;.067,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "-1.5,0;-1.5,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.25;.66099;.75;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M3 -1L0 -1 0 1 3 1 3 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.756;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code24",
    transform: "matrix(.1 0 0 1 14 21)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.161;.73899;.789;1",
    values: "13.9,21;13.9,21;13,21;13,21;13.9,21;13.9,21"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.161;.73899;.789;1",
    values: ".1,1;.1,1;1,1;1,1;.1,1;.1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "1,0;1,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.161;.73899;.789;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M0 -1L-2 -1 -2 1 0 1 0 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.794;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code23",
    transform: "translate(21 18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M0 3L0 0 -2 0 -2 2 -5 2 -5 4 -1 4Q-.6 4 -.3 3.7 0 3.4 0 3Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.944;1",
    values: "inline;none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(20 16.95)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.078;.161;.77799;.861;.939;1",
    values: "20,16.95;20,19.255;18.61,19.407;18.61,19.407;20,19.255;20,16.95;20,16.95"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.078;.161;.77799;.861;.939;1",
    values: "1,1;1,3.05;2.6,3.05;2.6,3.05;1,3.05;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.078;.161;.77799;.861;.939;1",
    values: "0,0;0,-.1;-.1,-.15;-.1,-.15;0,-.1;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.944;1",
    values: "inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_3)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer22_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 39.25 38 39.25 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.811;.817;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer21_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 38.55 38 38.55 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.806;.811;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer20_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 37.85 38 37.85 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.8;.806;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer19_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 37.15 38 37.15 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.794;.8;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer18_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 36.5 38 36.5 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.789;.794;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer17_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 35.8 38 35.8 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.783;.789;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer16_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 35.1 38 35.1 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.778;.783;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer15_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 34.4 38 34.4 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.772;.778;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer14_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33.7 38 33.7 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.767;.772;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer11_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33 38 33 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.767;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer10_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33.05 38 33.05 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.194;.2;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer9_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33.2 38 33.2 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.189;.194;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer8_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33.45 38 33.45 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.183;.189;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer7_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 33.85 38 33.85 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.178;.183;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer6_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 34.5 38 34.5 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.172;.178;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer5_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 35.4 38 35.4 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.172;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer4_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 36.55 38 36.55 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.167;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer3_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 38.05 38 38.05 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.156;.161;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 39.95 38 39.95 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.15;.156;.817;.978;1",
    values: "none;inline;none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M42 34Q42 33 41 33L29 33 29 35 40 35 40 38 39.95 38 39.95 40 41 40Q41.4 40 41.7 39.7 42 39.4 42 39L42 34Z"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.15;1",
    values: "inline;none;none"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(28 34)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.161;.81099;.867;.972;1",
    values: "28,34;35.95,33.549;35.625,36.517;35.625,36.517;35.95,33.549;28,34;28,34"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.161;.81099;.867;.972;1",
    values: "1,1;7.5,1.657;7.5,4.112;7.5,4.112;7.5,1.657;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.161;.81099;.867;.972;1",
    values: "0,0;-.2,-.15;-.15,-.15;-.15,-.15;-.2,-.15;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.978;1",
    values: "inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code22",
    transform: "matrix(1 0 0 .1 24 25)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.211;.66099;.711;1",
    values: "24,25.105;24,25.105;24,26;24,26;24,25.105;24,25.105"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.211;.66099;.711;1",
    values: "1,.1;1,.1;1,1;1,1;1,.1;1,.1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.211;.66099;.711;1",
    values: "0,-1.05;0,-1.05;0,-1;0,-1;0,-1.05;0,-1.05"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.211;.66099;.711;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 2L1 0 -1 0 -1 2 1 2Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.161;.717;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Code21",
    transform: "matrix(.033 0 0 1 31 21)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.88899;.994;1",
    values: "31.102,21;34,21;34,21;31.102,21;31.102,21"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.88899;.994;1",
    values: ".033,1;1,1;1,1;.033,1;.033,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.88899;.994;1",
    values: "-4.55,0;-3,0;-3,0;-4.55,0;-4.55,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.106;.88899;.994;1",
    values: ".25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M6 -1L0 -1 0 1 6 1 6 -1Z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code20",
    transform: "translate(7 24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M12 1Q12 0 11 0L0 0 0 2 10 2 10 4 12 4 12 1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.911;1",
    values: "none;inline;none;none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "mask",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.911;1",
    values: "none;url(#mask_2);none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(6 25)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.217;.272;.74399;.8;.906;1",
    values: "6,25;6,25;12.301,25;12.301,26.102;12.301,26.102;12.301,25;6,25;6,25"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.217;.272;.74399;.8;.906;1",
    values: "1,1;1,1;7.024,1;7.024,2.05;7.024,2.05;7.024,1;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.217;.272;.74399;.8;.906;1",
    values: "0,0;0,0;-.05,0;-.05,-.05;-.05,-.05;-.05,0;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.911;1",
    values: "none;inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code19",
    transform: "matrix(1 0 0 .143 26 33)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.272;.71699;.822;1",
    values: "26,33.5;26,33.5;26,36.5;26,36.5;26,33.5;26,33.5"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.272;.71699;.822;1",
    values: "1,.143;1,.143;1,1;1,1;1,.143;1,.143"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;1",
    values: "0,-3.5;0,-3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.272;.71699;.822;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 7L1 0 -1 0 -1 7 1 7Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.167;.828;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code18",
    transform: "matrix(.1 0 0 1 39 21)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.1;.15;.83899;.889;1",
    values: "39.105,21;39.105,21;40,21;40,21;39.105,21;39.105,21"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.1;.15;.83899;.889;1",
    values: ".1,1;.1,1;1,1;1,1;.1,1;.1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.1;.15;.83899;.889;1",
    values: "-1.05,0;-1.05,0;-1,0;-1,0;-1.05,0;-1.05,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.1;.15;.83899;.889;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M2 -1L0 -1 0 1 2 1 2 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.1;.894;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code17",
    transform: "matrix(.1 0 0 1 31 39)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.25;.71699;.767;1",
    values: "30.905,39;30.905,39;30,39;30,39;30.905,39;30.905,39"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.25;.71699;.767;1",
    values: ".1,1;.1,1;1,1;1,1;.1,1;.1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.25;.71699;.767;1",
    values: ".95,0;.95,0;1,0;1,0;.95,0;.95,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.25;.71699;.767;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M0 -1L-2 -1 -2 1 0 1 0 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.2;.772;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code16",
    transform: "matrix(1 0 0 .06 24 18)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.061;.167;.70599;.811;1",
    values: "24,18.151;24,18.151;24,20.5;24,20.5;24,18.151;24,18.151"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.061;.167;.70599;.811;1",
    values: "1,.06;1,.06;1,1;1,1;1,.06;1,.06"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.061;.167;.70599;.811;1",
    values: "0,-3.35;0,-3.35;0,-2.5;0,-2.5;0,-3.35;0,-3.35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.061;.167;.70599;.811;1",
    values: ".25;.25;1;1;.25;.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M1 5L1 0 -1 0 -1 5 1 5Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.061;.817;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code15",
    transform: "translate(20 40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M22 -11L1 -11Q0 -11 0 -10L0 0 2 0 2 -9 22 -9 22 -11Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.972;1",
    values: "none;inline;none;none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "mask",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.972;1",
    values: "none;url(#mask_1);none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(21 41)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.206;.3;.80599;.9;.967;1",
    values: "21,41;21,41;20.555,35.775;32.71,35.775;32.71,35.775;20.555,35.775;21,41;21,41"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.206;.3;.80599;.9;.967;1",
    values: "1,1;1,1;1.7,6.5;11.55,6.5;11.55,6.5;1.7,6.5;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.206;.3;.80599;.9;.967;1",
    values: "0,0;0,0;-.15,-.05;-.2,-.05;-.2,-.05;-.15,-.05;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.139;.972;1",
    values: "none;inline;none;none"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code14",
    transform: "translate(27 18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "none",
    d: "M14 6L2 6 2 0 0 0 0 7Q0 8 1 8L14 8 14 6Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.828;1",
    values: "none;inline;none;none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "mask",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.828;1",
    values: "none;url(#mask_);none;none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MASK",
    transform: "translate(28 17)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.189;.272;.66099;.744;.822;1",
    values: "28,17;28,17;27.573,21.25;34.335,21;34.335,21;27.573,21.25;28,17;28,17"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "scale",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.189;.272;.66099;.744;.822;1",
    values: "1,1;1,1;1.462,5.302;7.35,5.05;7.35,5.05;1.462,5.302;1,1;1,1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "sum",
    type: "translate",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.189;.272;.66099;.744;.822;1",
    values: "0,0;0,0;-.05,0;-.1,0;-.1,0;-.05,0;0,0;0,0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "4.5s",
    keyTimes: "0;.111;.828;1",
    values: "none;inline;none;none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/animation.d34bbe0e0fa22332a5d9bb188dec3ce2.svg";
export { ForwardRef as ReactComponent };